export const fontSize = {
  ULTRA_EXTRA_SMALL: '0.5rem', //8px
  EXTRA_SMALL: '0.625rem', //10px
  SMALL: '0.75rem', //12px
  NORMAL: '0.875rem', //14px
  MEDIUM: '1rem',
  LARGE: '1.125rem', //18px
  EXTRA_LARGE: '1.25rem', //20px
  ULTRA_EXTRA_LARGE: '1.375rem', //22px
  ULTRA_ULTRA_LARGE: '1.5rem', //24px
  ULTRA_ULTRA_ULTRA_LARGE: '2.25rem', //36px
  BIG_SIZE: '2rem',
}

export const fontsWeight = {
  BOLD: 'bold',
  MEDIUM: '500',
  NORMAL: 'normal',
  LIGHT: '300',
}

export const fontFamily = {
  IRANSANS: 'IRANSans',
  ARIAL: 'Arial',
}
